import React, { Component } from 'react';
import { Screen, Tap} from 'dooh-react-utils';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 1080px;
  height: 1920px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 95px 130px 0 130px;
`

const H1 = styled.div`
  color: white;
  font-size: 182px;
  font-family: "zabaBold";
  line-height: 90%;
`;

const H2 = styled.div`
  padding: 100px 0 15px 0;
  color: white;
  font-size: 95px;
  font-family: "zabaRegular";
  line-height: 96%;
  text-align: center;
`;

const TotalTime = styled.div`
  color: white;
  font-size: 217px;
  font-family: "zabaBold";
  line-height: 90%;
  text-align: center;
  padding-bottom: 95px;
`;

const Button = styled.div`
  width: 837px;
  height: 200px;
  margin: 20px 0 28px 0;
  background: #005a9c;
  color: white;
  font-size: 100px;
  font-family: "zabaBold";
  text-align: center;
  line-height: 200px;
  border: 1px solid #005a9c;
  border-radius: 12px;
`;

export default class GameLostScreen extends Component {
  render() {
    const game = this.props.game || {},
          time = game.time || 0;

    return (
      <Screen>
        <Wrapper>
          <H1>Čestitamo<br/>završili ste<br/>igru!</H1>
          <H2>Vaše vrijeme je:</H2>
          <TotalTime>{ (time / 1000).toFixed(1) } sec</TotalTime>
          <Tap onTap={this.props.gotoNextScreen}>
            <Button>Upiši se</Button>
          </Tap>
          <Tap onTap={this.handleRestart}>
            <Button>Pokušaj ponovno</Button>
          </Tap>
        </Wrapper>
      </Screen>
    );
  }

  handleRestart = () => {
    window.track('restart', {session: this.props.session});
    this.props.gotoScreen('game');
  }
}



// WEBPACK FOOTER //
// ./src/screens/GameWonScreen.js